<div class="actions-container" *appHideIfNotInRole="['vessels-crew-change-editor']">
  <button
    mat-stroked-button
    color="primary"
    [matMenuTriggerFor]="crewActionsMenu"
    class="actions-btn"
    >
    Actions
    <mat-icon>arrow_drop_down</mat-icon>
  </button>

  <mat-menu #crewActionsMenu="matMenu">
    <button mat-menu-item (click)="editCrew()">
      <span>Edit Crew</span>
    </button>

    @if (isCrewAvailable()) {
      <button
        mat-menu-item
        (click)="addCrewChange()">
        <span>New Crew Change</span>
      </button>
    }

    <!-- @if (crew && crew.crewChanges.length > 0) {
      <button
        mat-menu-item
        (click)="addAppraisal()"
        >
        <span>Appraisal</span>
      </button>
    } -->
  </mat-menu>
</div>
